<template>
  <div class="grid-view">
    <div class="main-content">
      <div v-if="$store.getters.enableFrontEndPlugin">
        <micro-app
          name="child-operation-date-query-remotebooking"
          :url="$store.getters.frontEndPluginUrl+'/operationDateQuery'"
          router-mode="pure"
          destroy
          @datachange="operationDateQueryDataChange"
        />
      </div>
      <search-item
        config-module="231503"
        :is-append-query="true"
        :reset="true"
        :custom-search-items="customSearchItems"
        :custom-sim-query-placeholder="$t('Message.QuickSearchBusinessNo')"
        @click-more="value=>{isAdvancedQuery=value}"
        @simSearchItemCallBack="toSimpleQuery"
        @advSearchItemCallBack="toAdvancedQuery"
        @defaultSearchItemsChange="value=>{defaultSearchItems=value}"
      >
        <template slot="operations">
          <el-button
            no="1"
            :disabled="!selectedRow"
            type="success"
            @click="toLook()"
          >{{ $t('common.btn.look') }}</el-button>
          <el-button
            no="2"
            :disabled="!selectedRow || selectedRow.preverifyState === 7"
            type="success"
            @click="toEdit"
          >{{ $t('common.btn.edit') }}
          </el-button>
          <el-button
            no="3"
            :disabled="!selectedRow"
            type="primary"
            @click="toCopy"
          >{{ $t('SeaExport.Copy') }}
          </el-button>
          <el-dropdown
            no="addSeHandle"
            split-button
            type="primary"
            style="margin:0 5px"
            @click="addSeHandle()"
            @command="p=>{addSeCommand=p;addSeHandle()}"
          >
            {{ addSeCommand }}
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                :command="$t('CargoMsg.Cargo_AddSeaBooking')"
              >{{ $t('CargoMsg.Cargo_AddSeaBooking') }}
              </el-dropdown-item>
              <el-dropdown-item
                :command="$t('CargoMsg.Cargo_IntelligentDocumentRecognition')"
              >{{ $t('CargoMsg.Cargo_IntelligentDocumentRecognition') }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown
            no="addAeHandle"
            split-button
            type="primary"
            style="margin:0 5px"
            @click="addAeHandle()"
            @command="p=>{addAeCommand=p;addAeHandle()}"
          >
            {{ addAeCommand }}
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                :command="$t('CargoMsg.Cargo_AddAirBooking')"
              >{{ $t('CargoMsg.Cargo_AddAirBooking') }}
              </el-dropdown-item>
              <el-dropdown-item
                :command="$t('CargoMsg.Cargo_IntelligentDocumentRecognition')"
              >{{ $t('CargoMsg.Cargo_IntelligentDocumentRecognition') }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button
            no="6"
            type="primary"
            @click="toAdd({lob:'RE'})"
          >{{ $t('CargoMsg.Cargo_AddRailwayBooking') }}</el-button>
          <el-button no="7" type="primary" :disabled="!selectedRow || selectedRow.preverifyState === 7" @click="$emit('lockJob',selectedRows)">{{ $t('CargoMsg.Cargo_HoldSubmission') }}</el-button>
          <el-button no="8" type="primary" :disabled="!selectedRow || selectedRow.preverifyState === 7" @click="$emit('submitJob',selectedRows)">{{ $t('CargoMsg.Cargo_Submit') }}</el-button>
          <el-button
            v-show="$checkPermission(['button_RemoteBooking_delete'])"
            no="9"
            :disabled="!selectedRow || selectedRow.preverifyState === 7"
            type="danger"
            @click="toDelete"
          >{{ $t('SeaExport.Delete') }}</el-button>
          <el-button
            v-show="isHc && $checkPermission(['button_RemoteBooking_revoke'])"
            no="revoke"
            :disabled="!selectedRow || selectedRow.preverifyState !== 4"
            type="danger"
            @click="toRevoke"
          >{{ $t('SeaExport.Invalid') }}</el-button>
        </template>
      </search-item>
      <div class="section grid-wrapper" style="min-height:350px">
        <cargo-ag-grid
          v-if="view === 'list'"
          config-module="23150101"
          :grid-options="gridOptions"
          :column-defs="finalColumnDefs"
          :row-data="rowData"
          :check-main-record="false"
          :deselect-main-record="false"
          :has-export-role="!isSalesForSzfs"
          style="width: 100%;"
          @gridReady="params=>{gridApi=params.api}"
        />
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          v-show="!appendQuery"
          config-module="23150101"
          :total="total"
          :page.sync="pageNum"
          :limit.sync="pageSize"
          @pagination="()=>{if(total>0){toQuery()}}"
        />
        <div v-show="appendQuery" class="pagination-container">
          <el-pagination
            style="text-align: left;"
            :total="total"
            layout="total"
          />
        </div>
      </div>
    </div>
    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.ctx"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :context="context"
      :pre-print-callback="prePrintCallback"
      :printed-callback="printedCallback"
      :v2-check-callback="v2CheckCallback"
    />
  </div>
</template>

<script>
import jobDetailIcon from '@/assets/job-detail.png'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { DocumentManage, ensureExecuteSuccess, stopBubble } from '@/utils/commonUtil'
import ColumnUtils from '@/utils/ColumnUtils'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import AdvancedSearchConsts from '@/class/cargo/model/parameters/OperatorConstants'
import {
  HC_REMOTE_BOOKING_ALL_STATES,
  VERIFYING_AUDITED,
  INTELLIGENT_DOCUMENT_SOURCE_REMOTE_SE, AE, INTELLIGENT_DOCUMENT_SOURCE_REMOTE_AE
} from '@/class/cargo/model/parameters/SystemConstants'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import * as LayersUtil from '@/class/cargo/model/utils/LayersUtil'
import { Job } from '@/class/model/booking/Job'
import { User } from '@/class/model/sys/User'
import { remoteBookingQuery, validateDelJob, batchDeleteJob, validateRevokeJob, batchRevokeJob } from '@/api/booking/job'
import { getLoading } from '@/utils/utilBaseElement'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { matchView, refreshView } from '@/store/modules/tagsView'
import { OPERATOR_EQUAL, OPERATOR_IN, OPERATOR_UNEQUAL } from '@/class/cargo/model/utils/AdvancedSearchConsts'
import microApp from '@micro-zoe/micro-app'
import * as UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'
import { UICustomUtil } from '@/class/cargo/model/utils/UICustomUtil'

export default {
  name: 'RemoteBookingTreeGrid',
  components: { searchItem, cargoTemplateSelectorDialog },
  props: {
    view: { type: String, default: 'list' },
    context: { type: Object, required: true },
    isSalesForSzfs: { type: Boolean, default: false } // 深圳丰收销售专用
  },
  data() {
    const isZh = this.$store.getters.language === 'zh'
    return {
      appendQuery: false, // 追加查询
      isZh,
      customSearchItems: [],
      isAdvancedQuery: false, // 是否为高级查询
      pageNum: 1,
      pageSize: 50,
      total: 0,
      rowData: [],
      // selectedRowIndex: -1,
      selectedRows: [],
      selectedRow: null,
      templateSelectorDialog: {
        visible: false,
        ctx: null,
        category: '',
        data: {}
      },
      prePrintCallback: null,
      printedCallback: null,
      v2CheckCallback: null,
      addSeCommand: this.$t('CargoMsg.Cargo_AddSeaBooking'),
      addAeCommand: this.$t('CargoMsg.Cargo_AddAirBooking'),
      columnDefs: [],
      operationDateQuery: { // 操作日期查询条件、显示列
        viewSource: 'RemoteBooking',
        searchItem: false, // 查询条件
        columnItem: false // 显示列
      },
      operationDateQuerySearch: false,
      operationDateQueryColumn: false,
      isHc: false,
      defaultSearchItems: [],
      elementDict: {}
    }
  },
  computed: {
    filter() {
      return this.isAdvancedQuery ? this.complexFilter : this.simpleFilter
    },
    // selectedRow() {
    //   if (this.rowData.length === 1) {
    //     return this.rowData[0]
    //   }
    //   return this.rowData[this.selectedRowIndex]
    // },
    batchSelectFlag() {
      return this.selectedRows.length > 0
    },
    submitState() {
      return this.selectedRow && (this.selectedRow.preverifyState === 3 || this.selectedRow.preverifyState === 4)
    },
    finalColumnDefs() {
      if (this.$store.state.uiCustom.enable) {
        return UICustomUtil.handleColumnLabelAndDisplay(this.columnDefs, this.elementDict, (columnDef, element) => element.customLabel || columnDef.headerName)
      }
      return this.columnDefs
    }
  },
  watch: {
    '$store.getters.currentOfficeId': {
      async handler() {
        this.loadPageConfig()
        this.customSearchItems = await this.getCustomSearchItems()
      }
    },
    async defaultSearchItems() {
      this.customSearchItems = await this.getCustomSearchItems()
    }
  },
  async created() {
    this.TYPE_NAMES = TYPE_NAMES
    this.simpleFilter = {
      conditions: [],
      branchId: 0
    }
    this.complexFilter = {
      conditions: [],
      branchId: 0
    }
    this.gridOptions = {
      rowSelection: 'multiple',
      suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
      suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择。当您想要专门选择复选框时使用。
      treeData: true,
      groupDefaultExpanded: 2,
      getDataPath: data => {
        return data.path.split(',')
      },
      autoGroupColumnDef: {
        headerName: this.$t('SeaExport.BusinessNo'),
        colId: 'jobNo',
        field: 'jobNo',
        width: 240,
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        cellRendererParams: {
          suppressCount: true,
          suppressDoubleClickExpand: true,
          checkbox: params => {
            const currentJob = params.data
            if (currentJob.hasOwnProperty('dataType') && Number(currentJob.dataType) !== 1 && Number(currentJob.dataType) !== 2) {
              return false
            }
            return true
          },
          innerRenderer: params => {
            const methodPath = this.documentManage.getPath('showBusinessInfo')
            return `<span>${params.value}<img src="${jobDetailIcon}" height="16" width="16" style="vertical-align: sub;margin-left:3px;cursor:pointer" onclick="${methodPath}(event)"/></span>`
          }
        }
      },
      onRowDataChanged: event => {
        // 重置（多选）选中行
        this.selectedRows = []
        this.selectedRow = null
      },
      // 单选（勾选框或者其他列，都会触发）
      onCellFocused: (event) => {
        this.onGridCellFocused(event)
        // this.selectedRowIndex = event.rowIndex
      },
      // 多选（勾选框触发）
      onRowSelected: (event) => {
        this.selectedRows = this.gridApi.getSelectedRows()
        // if (this.selectedRows.length > 0) {
        //   this.selectedRow = this.selectedRows[0]
        // }
      },
      onCellDoubleClicked: event => {
        this.toLook(event.data)
      },
      getRowStyle: params => {
        const row = params.data
        const colorType = Number(this.$store.state.settings.colorType) === 1
        if (colorType) {
          return JobUtils.financeColor(row)
        } else if (row.hasOwnProperty('dataType') && (Number(row.dataType) === 1 || Number(row.dataType) === 2)) {
          if (Object.prototype.hasOwnProperty.call(row, 'blocked') &&
            Object.prototype.hasOwnProperty.call(row, 'specialApproval') &&
            JobUtils.isBlockJob(row)) {
            return { 'background': LayersUtil.STATE_BLOCKED.colorValue }
          } else {
            const jobState = String(row.jobState) || ''
            for (const stateColor of LayersUtil.COLOR_STATES) {
              if (jobState === stateColor.colorKey) {
                return { 'background': stateColor.colorValue }
              }
            }
          }
        }
        return {}
      },
      defaultColDef: {
        resizable: true
      },
      context: {
        componentParent: this
      }
    }
    this.columnDefs = [
      {
        headerName: this.$t('CargoMsg.Cargo_AuthorizedClient'),
        field: 'customerId',
        cellRenderer: params => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
        },
        width: 200
      }, {
        headerName: this.$t('CargoMsg.Cargo_RiskReason'),
        field: 'riskReason',
        width: 150
      }, {
        headerName: this.$t('CargoMsg.Cargo_PortOfLoading'),
        field: 'loadingPortCode',
        cellRenderer: params => {
          if (params.data.lob === 'SE') {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          } else if (params.data.lob === 'AE') {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'englishName')
          } else if (params.data.lob === 'RE' || params.data.lob === 'RI') {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.data.departureStation, 'englishName')
          }
          return ''
        },
        width: 180
      }, {
        headerName: this.$t('CargoMsg.Cargo_DestinationPort'),
        field: 'destinationPortCode',
        cellRenderer: params => {
          if (params.data.lob === 'SE') {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          } else if (params.data.lob === 'AE') {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'englishName')
          } else if (params.data.lob === 'RE' || params.data.lob === 'RI') {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.data.destinationStation, 'englishName')
          }
          return ''
        },
        width: 180
      }, {
        headerName: this.$t('CargoMsg.Cargo_Carrier'),
        field: 'carrierId',
        cellRenderer: params => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
        },
        width: 200
      }, {
        headerName: this.$t('CargoMsg.Cargo_SailingDate'),
        field: 'etd',
        cellRenderer: params => {
          return ColumnUtils.dateLabelFunc(params.value)
        },
        width: 120
      }, {
        headerName: this.$t('CargoMsg.Cargo_ArrivalDate'),
        field: 'eta',
        cellRenderer: params => {
          return ColumnUtils.dateLabelFunc(params.value)
        },
        width: 120
      }, {
        headerName: this.$t('CargoMsg.Cargo_Creator'),
        field: 'createdBy',
        cellRenderer: params => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
        },
        width: 120
      }, {
        headerName: this.$t('CargoMsg.Cargo_CreatedDate'),
        field: 'dateCreated',
        cellRenderer: params => {
          return ColumnUtils.dateLabelFunc(params.value)
        },
        width: 120
      }, {
        headerName: this.$t('CargoMsg.Cargo_WarehouseNo'),
        field: 'warehouseNo',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('CargoMsg.Cargo_ItemNo'),
        field: 'poNo',
        hide: true,
        width: 120
      }, {
        headerName: this.$t('CargoMsg.Cargo_BusinessType'),
        field: 'lob',
        cellRenderer: params => {
          if (params.value === 'SE') {
            return this.$t('CargoMsg.Cargo_OceanExport')
          } else if (params.value === 'AE') {
            return this.$t('CargoMsg.Cargo_AirExport')
          } else if (params.value === 'RE') {
            return this.$t('CargoMsg.Cargo_RailwayExport')
          } else if (params.value === 'RI') {
            return this.$t('CargoMsg.Cargo_RailwayImport')
          }
          return ''
        },
        width: 120
      }, {
        headerName: this.$t('CargoMsg.Cargo_OperationType'),
        field: 'operationType',
        cellRenderer: params => {
          if (params.data.lob === 'SE') {
            return ColumnUtils.containerLoadTypeLabelFunction(params.data, 'containerLoadType')
          } else if (params.data.lob === 'AE') {
            return ColumnUtils.operateTypeLabelFunc(params.data, 'operateType')
          }
          return ''
        },
        width: 120
      }, {
        headerName: this.$t('CargoMsg.Cargo_SolicitationType'),
        field: 'cargoSource',
        cellRenderer: params => {
          return ColumnUtils.cargoSourceLabelFunction(params.value)
        },
        hide: true,
        width: 120
      }, {
        headerName: this.$t('CargoMsg.Cargo_Operation'),
        field: 'op',
        cellRenderer: params => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
        },
        width: 120
      }, {
        headerName: this.$t('CargoMsg.Cargo_Sales'),
        field: 'sales',
        cellRenderer: params => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
        },
        width: 120
      }, {
        headerName: this.$t('CargoMsg.Cargo_PreReviewStatus'),
        field: 'preverifyState',
        cellRenderer: params => {
          const fieldName = this.isZh ? 'chineseName' : 'englishName'
          for (const item of HC_REMOTE_BOOKING_ALL_STATES) {
            if (item.code === params.value) {
              return item[fieldName]
            }
          }
          return VERIFYING_AUDITED[fieldName]
        },
        width: 120
      }, {
        headerName: this.$t('CargoMsg.Cargo_IncoTerm'),
        field: 'incoTerm',
        width: 120,
        tooltipValueGetter: params => params.value,
        hide: true
      }, {
        headerName: this.$t('SeaExport.UserDefinedField1'),
        field: 'userDefinedField1',
        width: 120,
        tooltipValueGetter: params => params.value,
        hide: true
      }, {
        headerName: this.$t('CargoMsg.Cargo_Remarks'),
        field: 'remarks',
        width: 120,
        tooltipValueGetter: params => params.value,
        hide: true
      }, {
        headerName: this.$t('SeaExport.UserDefinedField2'),
        field: 'userDefinedField2',
        width: 120,
        tooltipValueGetter: params => params.value,
        hide: true
      }, {
        headerName: this.$t('SeaExport.UserDefinedField3'),
        field: 'userDefinedField3',
        width: 120,
        tooltipValueGetter: params => params.value,
        hide: true
      }, {
        headerName: this.$t('SeaExport.UserDefinedField4'),
        field: 'userDefinedField4',
        width: 120,
        tooltipValueGetter: params => params.value,
        hide: true
      },
      {
        headerName: this.$t('CargoMsg.Cargo_PrePortBusinessLeader'),
        field: 'prePortPlanner',
        colId: 'prePortPlanner',
        width: 100,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value || 0), 'chineseName')
        }
      },
      {
        headerName: this.$t('CargoMsg.Cargo_LastMileBusinessLeader'),
        field: 'lastMilePlanner',
        colId: 'lastMilePlanner',
        width: 100,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value || 0), 'chineseName')
        }
      }, {
        headerName: this.$t('CargoMsg.Cargo_preportAuditStatus'),
        field: 'prePortApproveStatus',
        colId: 'prePortApproveStatus',
        enableRowGroup: true,
        valueGetter: (params) => {
          return ColumnUtils.priceJobStateLabelFunc(params.data.prePortPlanner, Number(params.data.prePortApproveStatus))
        },
        filterParams: {},
        filterValueGetter: (params) => {
          return ColumnUtils.priceJobStateLabelFunc(params.data.prePortPlanner, Number(params.data.prePortApproveStatus))
        },
        width: 150
      }, {
        headerName: this.$t('CargoMsg.Cargo_TrunkLineAuditStatus'),
        field: 'trunkLineApproveStatus',
        colId: 'trunkLineApproveStatus',
        enableRowGroup: true,
        valueGetter: (params) => {
          return ColumnUtils.priceJobStateLabelFunc(params.data.planner, Number(params.data.trunkLineApproveStatus))
        },
        filterParams: {},
        filterValueGetter: (params) => {
          return ColumnUtils.priceJobStateLabelFunc(params.data.planner, Number(params.data.trunkLineApproveStatus))
        },
        width: 150
      }, {
        headerName: this.$t('CargoMsg.Cargo_TailEndAuditStatus'),
        field: 'lastMileApproveStatus',
        colId: 'lastMileApproveStatus',
        enableRowGroup: true,
        valueGetter: (params) => {
          return ColumnUtils.priceJobStateLabelFunc(params.data.lastMilePlanner, Number(params.data.lastMileApproveStatus))
        },
        filterParams: {},
        filterValueGetter: (params) => {
          return ColumnUtils.priceJobStateLabelFunc(params.data.lastMilePlanner, Number(params.data.lastMileApproveStatus))
        },
        width: 150
      }, {
        headerName: this.$t('SeaExport.quotationNum'),
        colId: 'quotationNo',
        field: 'quotationNo',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.ActualDateOfDeparture2'),
        field: 'atd',
        colId: 'atd',
        cellRenderer: (params) => {
          return ColumnUtils.dateLabelFunc(params.value)
        },
        width: 150
      }, {
        headerName: this.$t('SeaExport.ActualDateOfArrival2'),
        field: 'ata',
        colId: 'ata',
        cellRenderer: (params) => {
          return ColumnUtils.dateLabelFunc(params.value)
        },
        width: 150
      }, {
        headerName: this.$t('CargoMsg.Cargo_AirlinePerson'),
        field: 'planner',
        colId: 'planner',
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
        },
        width: 150
      }, {
        headerName: this.$t('SeaExport.AirlineDepartment'),
        field: 'plannerDepartment',
        colId: 'plannerDepartment',
        hide: true,
        width: 140,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department_All, 'departmentId', Number(params.value), 'chineseName')
        }
      }, {
        headerName: this.$t('CargoMsg.Cargo_CustomerService'),
        field: 'csr',
        colId: 'csr',
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
        },
        width: 150
      }, {
        headerName: this.$t('CargoMsg.Cargo_Documents'),
        field: 'dc',
        colId: 'dc',
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
        },
        width: 150
      }, {
        headerName: this.$t('SeaExport.ProjectName'),
        field: 'projectName',
        colId: 'projectName',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.ProjectBatch'),
        field: 'projectBatch',
        colId: 'projectBatch',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('queryJob.CommissionedDensity'),
        field: 'densityContract',
        hide: true,
        width: 100,
        cellRenderer: params => {
          return params.value ? ColumnUtils.number3ColumnLabelFunc(params.value) : ''
        }
      }, {
        headerName: this.$t('Message.TerminalCompany'),
        colId: 'terminalCompany',
        field: 'terminalCompany',
        width: 180,
        hide: true,
        valueFormatter: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
        }
      }, {
        headerName: this.$t('SeaExport.CargoType'),
        field: 'cargoType',
        colId: 'cargoType',
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CargoType, 'code', params.value, 'chineseName')
        },
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.MasterBLFreightTerm'),
        field: 'paymentTermMBL',
        colId: 'paymentTermMBL',
        hide: true,
        width: 150,
        valueGetter: (params) => {
          if (params.data) {
            return ColumnUtils.paymentTermLabelFunc(params.data.paymentTermMBL)
          }
          return ''
        }
      }, {
        headerName: this.$t('SeaExport.HBLFreightClause'),
        field: 'paymentTermHBL',
        colId: 'paymentTermHBL',
        hide: true,
        width: 150,
        valueGetter: (params) => {
          if (params.data) {
            return ColumnUtils.paymentTermLabelFunc(params.data.paymentTermHBL)
          }
          return ''
        }
      },
      {
        headerName: this.$t('Partners.Refuser'),
        field: 'refuser',
        hide: true,
        width: 180,
        filterParams: {},
        filterValueGetter: (params) => {
          return params.data.preverifyState === 3 ? ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.data.refuser, 'chineseName') : ''
        },
        valueFormatter: (params) => {
          return params.data.preverifyState === 3 ? ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName') : ''
        }
      },
      {
        headerName: this.$t('CargoMsg.Cargo_DenialReason'),
        field: 'bookingRefuseNote',
        hide: true,
        filterParams: {},
        filterValueGetter: (params) => {
          return params.data.preverifyState === 3 ? params.data.bookingRefuseNote : ''
        },
        valueFormatter: (params) => {
          return params.data.preverifyState === 3 ? params.value : ''
        },
        width: 200
      },
      {
        headerName: this.$t('CargoMsg.Cargo_IsCabinSpace'), field: 'availableCabinSpace', width: 180, colId: 'availableCabinSpace', hide: true,
        cellRenderer: (params) => {
          return ColumnUtils.booleanLabelFunction(params.value)
        }
      },
      {
        headerName: this.$t('Partners.RefuseDate'),
        field: 'refuseDate',
        hide: true,
        width: 150,
        filterParams: {},
        filterValueGetter: (params) => {
          return params.data.preverifyState === 3 ? ColumnUtils.dateLabelFunc(params.data.refuseDate) : ''
        },
        cellRenderer: params => {
          return params.data.preverifyState === 3 ? ColumnUtils.dateLabelFunc(params.value) : ''
        }
      }, {
        headerName: this.$t('SeaExport.Marks'),
        field: 'mark',
        colId: 'mark',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.CustomerOffice'),
        field: 'csrOffice',
        colId: 'csrOffice',
        hide: true,
        width: 100,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', params.value, 'chineseName')
        }
      }, {
        headerName: this.$t('SeaExport.DocumentOffice'),
        field: 'dcOffice',
        colId: 'dcOffice',
        hide: true,
        width: 100,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', params.value, 'chineseName')
        }
      },
      // 箱型描述
      {
        headerName: this.$t('SeaExport.ContainerDescription'),
        field: 'containerDesc',
        colId: 'containerDesc',
        hide: true,
        width: 150
      },
      {
        headerName: this.$t('CargoMsg.Cargo_ReturnModule'),
        field: 'returnType',
        colId: 'returnType',
        hide: true,
        width: 150,
        filterParams: {},
        filterValueGetter: (params) => {
          const type = Number(params.data && params.data.returnType)
          if (type === 1) return this.$t('CargoMsg.Cargo_BookingPreAudit')
          if (type === 2) return this.$t('CargoMsg.Cargo_RemoteBooking')
          return ''
        },
        valueGetter: (params) => {
          const type = Number(params.data && params.data.returnType)
          if (type === 1) return this.$t('CargoMsg.Cargo_BookingPreAudit')
          if (type === 2) return this.$t('CargoMsg.Cargo_RemoteBooking')
          return ''
        }
      },
      {
        headerName: this.$t('CargoMsg.Cargo_ReturnReason'),
        field: 'returnRemark',
        colId: 'returnRemark',
        hide: true,
        width: 150
      },
      {
        headerName: this.$t('SeaExport.NCReferenceNo'),
        field: 'agentRefNo',
        colId: 'agentRefNo',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.TaxNature'),
        field: 'taxNature',
        colId: 'taxNature',
        cellRenderer: params => {
          return ColumnUtils.taxNatureLabelFunction(params.value)
        },
        width: 120
      },
      { headerName: this.$t('CargoMsg.Cargo_userDefinedRole1'),
        field: 'userDefinedRoleId1',
        colId: 'userDefinedRoleId1',
        enableRowGroup: true,
        width: 140,
        valueFormatter: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
        }
      },
      { headerName: this.$t('CargoMsg.Cargo_userDefinedRole2'),
        field: 'userDefinedRoleId2',
        colId: 'userDefinedRoleId2',
        enableRowGroup: true,
        width: 140,
        valueFormatter: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
        }
      },
      { headerName: this.$t('CargoMsg.Cargo_userDefinedRole3'),
        field: 'userDefinedRoleId3',
        colId: 'userDefinedRoleId3',
        enableRowGroup: true,
        hide: true,
        width: 140,
        valueFormatter: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
        }
      },
      { headerName: this.$t('CargoMsg.Cargo_userDefinedRole4'),
        field: 'userDefinedRoleId4',
        colId: 'userDefinedRoleId4',
        enableRowGroup: true,
        hide: true,
        width: 140,
        valueFormatter: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
        }
      },
      { headerName: this.$t('CargoMsg.Cargo_userDefinedRole5'),
        field: 'userDefinedRoleId5',
        colId: 'userDefinedRoleId5',
        enableRowGroup: true,
        hide: true,
        width: 140,
        valueFormatter: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
        }
      },
      { headerName: this.$t('CargoMsg.Cargo_userDefinedRole6'),
        field: 'userDefinedRoleId6',
        colId: 'userDefinedRoleId6',
        enableRowGroup: true,
        hide: true,
        width: 140,
        valueFormatter: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
        }
      },
      { headerName: this.$t('CargoMsg.Cargo_userDefinedRole7'),
        field: 'userDefinedRoleId7',
        colId: 'userDefinedRoleId7',
        enableRowGroup: true,
        hide: true,
        width: 140,
        valueFormatter: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
        }
      }
    ]
    if (!this.isSalesForSzfs) {
      this.columnDefs.push(
        {
          headerName: this.$t('CargoMsg.Cargo_DestinationAgent'),
          field: 'destinationAgent',
          cellRenderer: params => {
            if (params.data.lob === 'RE' || params.data.lob === 'RI') {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'shortName')
          },
          width: 200
        }
      )
    }
    this.gridApi = null
    this.documentManage = new DocumentManage()
    await this.context.prepareData()
    this.isHc = String(this.context.config.get('ToExoSystem')) === 'HC'
    this.loadPageConfig()
    await this.getCustomSearchItems().then(data => {
      this.customSearchItems = data
    })
  },
  beforeMount() {
    const self = this
    this.documentManage.set('showBusinessInfo', function() {
      self.showBusinessInfo()
    })
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: {
    loadPageConfig() {
      if (!this.$store.state.uiCustom.enable) {
        return
      }
      const pageConfig = UICustomUtil.getPageConfig(UICustomConstants.REMOTE_BOOKING_LIST, this.$store.getters.currentOfficeId)
      this.elementDict = pageConfig.elementDict
      UICustomUtil.handleViewAndWrite(UICustomConstants.REMOTE_BOOKING_LIST, this.elementDict)
    },
    async getCustomSearchItems() {
      const result = []
      /* 销售 */
      let searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'advanceSelect'
      searchField.fieldType = 'FIELD_DROP_DOWN_LIST'
      searchField.itemName = 'job.SALES_ID'
      searchField.itemLabel = 'CargoMsg.Cargo_Sales'
      searchField.defaultSelected = 1
      searchField.subType = { filterable: true }
      searchField.dataProvider = Array.from((await User.getUsersByPrivilegeDetail('role', 'sales', null, null, true)), p => {
        return { code: p.userId, chineseName: p.chineseName, englishName: p.englishName }
      })
      searchField.filterType = 'global'
      searchField.dataCacheKey = 'local_cache_SystemConstants$Common'
      result.push(searchField.formatObj2Json())
      /* 创建人 */
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'advanceSelect'
      searchField.fieldType = 'FIELD_DROP_DOWN_LIST'
      searchField.itemName = 'job.CREATED_BY'
      searchField.itemLabel = 'CargoMsg.Cargo_Creator'
      searchField.defaultSelected = 1
      searchField.subType = { filterable: true }
      searchField.dataProvider = Array.from((await User.getUsersByPrivilegeDetail('role', null, null, null, true)), p => {
        return { code: p.userId, chineseName: p.chineseName, englishName: p.englishName }
      })
      searchField.filterType = 'global'
      searchField.dataCacheKey = 'local_cache_SystemConstants$Common'
      result.push(searchField.formatObj2Json())
      if (Number(this.context.config.get('PretrialReview')) === 1) {
        result.push({
          'action': AdvancedSearchField.UPDATE_ACTION,
          'itemType': 'select',
          'multiple': 1,
          'itemCondition': [],
          'defaultConditionVal': '',
          'fieldType': 'FIELD_MULTI_DROP_DOWN_LIST',
          'itemName': 'job.PREVERIFY_STATE',
          'itemLabel': 'CargoMsg.Cargo_PreReviewStatus',
          'itemValue': [],
          'defaultSelected': 1,
          'selected': 0,
          'dropdownDataRef': this.isHc ? 'SystemConstants.HC_REMOTE_BOOKING_ALL_STATES' : 'SystemConstants.REMOTE_BOOKING_ALL_STATES',
          'dataCacheKey': this.isHc ? 'local_cache_SystemConstants$HC_REMOTE_BOOKING_ALL_STATES' : 'local_cache_SystemConstants$REMOTE_BOOKING_ALL_STATES',
          'valueExpression': '',
          'headers': [],
          'fields': [],
          'tagValue': '',
          'tagName': '',
          'lock': false,
          'defaultValue': []
        })
      } else {
        result.push({
          'action': AdvancedSearchField.UPDATE_ACTION,
          'itemType': 'select',
          'multiple': 1,
          'itemCondition': [],
          'defaultConditionVal': '',
          'fieldType': 'FIELD_MULTI_DROP_DOWN_LIST',
          'itemName': 'job.PREVERIFY_STATE',
          'itemLabel': 'CargoMsg.Cargo_PreReviewStatus',
          'itemValue': [],
          'defaultSelected': 1,
          'selected': 0,
          'dropdownDataRef': this.isHc ? 'SystemConstants.HC_REMOTE_BOOKING_STATES' : 'SystemConstants.REMOTE_BOOKING_STATES',
          'dataCacheKey': this.isHc ? 'local_cache_SystemConstants$HC_REMOTE_BOOKING_STATES' : 'local_cache_SystemConstants$REMOTE_BOOKING_STATES',
          'valueExpression': '',
          'headers': [],
          'fields': [],
          'tagValue': '',
          'tagName': '',
          'lock': false,
          'defaultValue': []
        })
      }
      /* 委托单位 */
      searchField = new AdvancedSearchField()
      searchField.itemType = 'company'
      searchField.subType = {
        'type': 'customer',
        'tagValue': 'cmpIdx',
        'useSales': true
      }
      searchField.fieldType = 'FIELD_CUSTOMER'
      searchField.itemName = 'job.CUSTOMER_ID'
      searchField.itemLabel = 'CargoMsg.Cargo_AuthorizedClient'
      searchField.defaultSelected = 1
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      result.push(searchField.formatObj2Json())

      // CARGO-40541 世派：远程订舱添加承运人筛选条件和箱型箱量设置列
      // 船公司
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.ADD_ACTION
      searchField.itemType = 'company'
      searchField.subType = { 'type': 'seaCmp', 'tagValue': 'cmpIdx' }
      searchField.fieldType = 'FIELD_CARRIER'
      searchField.itemName = 'job.CARRIER_ID'
      searchField.itemLabel = 'SeaExport.ShippingCompany'
      searchField.defaultSelected = 1
      searchField.itemCondition = [OPERATOR_EQUAL, OPERATOR_UNEQUAL, OPERATOR_IN]
      result.push(searchField.formatObj2Json())

      // 航空公司
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.ADD_ACTION
      searchField.itemType = 'company'
      searchField.subType = { 'type': 'airCmp', 'tagValue': 'cmpIdx' }
      searchField.fieldType = 'FIELD_AIR_COMPANY'
      searchField.itemName = 'job.CARRIER_ID'
      searchField.itemLabel = 'SeaExport.AirlineCompany'
      searchField.defaultSelected = 1
      searchField.itemCondition = [OPERATOR_EQUAL, OPERATOR_UNEQUAL, OPERATOR_IN]
      result.push(searchField.formatObj2Json())

      if (this.isSalesForSzfs) {
        searchField = new AdvancedSearchField()
        searchField.fieldType = 'FIELD_SEA_DEST_AGENT'
        searchField.itemName = 'job.DESTINATION_AGENT'
        searchField.itemLabel = 'SeaExport.DestinationAgent'
        searchField.action = AdvancedSearchField.REMOVE_ACTION
        result.push(searchField.formatObj2Json())
      }
      // 操作日期
      if (this.operationDateQuerySearch) {
        searchField = new AdvancedSearchField()
        searchField.action = 0
        searchField.itemType = 'date'
        searchField.subType = 'range'
        searchField.fieldType = 'FIELD_DATE_RANGE'
        searchField.itemCondition = []
        searchField.defaultConditionVal = ''
        searchField.itemName = 'job.CUSTOMS_DATE'
        searchField.itemLabel = 'SeaExport.OperationDate'
        searchField.itemValue = []
        searchField.selected = 0
        searchField.valueExpression = ''
        searchField.lock = false
        searchField.defaultValue = []
        result.push(searchField.formatObj2Json())
      }
      if (this.$store.state.uiCustom.enable) {
        UICustomUtil.handleSearchItems(UICustomConstants.REMOTE_BOOKING_MODULE, this.defaultSearchItems, result, UICustomConstants.REMOTE_BOOKING_LIST, true)
      }
      return result
    },
    // 查询[简单查询/高级查询]
    toQuery() {
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery()
      } else {
        this.toSimpleQuery()
      }
    },
    // 简单查询
    toSimpleQuery(keyword) {
      this.appendQuery = false // 关闭追加查询
      let data
      if (typeof keyword !== 'undefined') {
        data = [
          new AdvancedSearchOption(null, 'job.JOB_NO', keyword, 'LIKE').formatObj2Json()
        ]
      }
      this.toAdvancedQuery(data)
    },
    // 高级查询
    toAdvancedQuery(data) {
      const filter = this.filter
      if (typeof data !== 'undefined') {
        // 高级查询条件组装
        filter.conditions = this.handleConditionsBeforeQuery(data)
        // 获取追加查询条件
        this.appendQuery = JobUtils.appendQueryCondition(filter.conditions)
        this.pageNum = 1
      }
      filter.branchId = this.$store.getters.currentOfficeId
      filter.pageNum = this.pageNum
      filter.pageSize = this.pageSize
      filter.appendQuery = this.appendQuery
      const colorType = Number(this.$store.state.settings.colorType) === 1
      if (colorType) {
        // 开启了财务颜色显示
        filter.requires = ['financeColor']
      }
      const loading = getLoading()
      this.context.loading = true
      remoteBookingQuery(filter).then(res => {
        let results = res.data.list
        if (this.appendQuery) { // 追加查询数据去重
          results = JobUtils.appendQueryRepeat(this.rowData, results, this.appendQuery)
          this.total = results.length
        } else {
          this.pageNum = res.data.pageNum
          this.pageSize = res.data.pageSize
          this.total = Number(res.data.total)
        }
        this.rowData = results
        this.selectedRow = null
        this.gridApi.clearFocusedCell()
      }).finally(() => {
        loading.close()
        this.context.loading = false
      })
    },
    // 在查询之前，对条件进行预处理
    handleConditionsBeforeQuery(data) {
      data.push(new AdvancedSearchOption(null, 'job.SALES_OFFICE', this.$store.getters.currentOfficeId).formatObj2Json())
      // CARGO-37309 远程订舱 不对 交叉委托业务进行过滤
      // data.push(new AdvancedSearchOption(null, 'job.TRUST_FROM_JOB', true, AdvancedSearchConsts.OPERATOR_IS_NULL.code).formatObj2Json())
      // data.push(new AdvancedSearchOption(null, 'job.RELATED_JOB', true, AdvancedSearchConsts.OPERATOR_IS_NULL.code).formatObj2Json())
      if (this.isAdvancedQuery && !AdvancedSearchOption.hasField('job.PREVERIFY_STATE', data)) {
        const value = this.isHc ? [1, 2, 3, 4, 7] : [1, 3, 4]
        data.push(new AdvancedSearchOption(null, 'job.PREVERIFY_STATE', value, AdvancedSearchConsts.OPERATOR_IN.code).formatObj2Json())
      }
      if (!AdvancedSearchOption.hasField('job.LOB', data)) {
        data.push(new AdvancedSearchOption(null, 'job.LOB', ['SE', 'AE', 'RE', 'RI'], AdvancedSearchConsts.OPERATOR_IN.code).formatObj2Json())
      }
      return data
    },
    // 业务编号右边放大镜图标点击事件处理
    showBusinessInfo(e) {
      stopBubble(e)
      this.templateSelectorDialog.ctx = new Job(this.selectedRow)
      this.templateSelectorDialog.category = 'JOB_DETAIL_OP'
      this.templateSelectorDialog.data = { 'JOB_UUID': this.selectedRow.uuid }
      this.templateSelectorDialog.visible = true
    },
    // 查看
    toLook(row) {
      this.$emit('look', row || this.selectedRow)
    },
    // 编辑
    toEdit() {
      this.$emit('edit', this.selectedRow)
    },
    // 复制
    toCopy() {
      this.$emit('copy', this.selectedRow)
    },
    // 新增
    toAdd(row) {
      this.$emit('add', row)
    },
    // 删除
    async toDelete() {
      const rows = this.selectedRows
      for (const row of rows) {
        if (row.preverifyState !== 4 && row.preverifyState !== 3) {
          this.$message.warning(this.$t('CargoMsg.Cargo_NotSubmittedOrRejectedTips'))
          return
        }
      }
      if (rows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectDataToDelete'))
        return
      }
      if (rows.length > 50) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SelectedMoreThenNPieces', [50]))
        return
      }
      const jobKeys = Array.from(rows, p => p.uuid)
      this.context.loading = true
      const loading = getLoading()
      const res = await validateDelJob({ jobKeys }).finally(() => {
        loading.close()
        this.context.loading = false
      })
      this.handlerDelete(res.data, jobKeys)
    },
    // 删除验证结果
    handlerDelete(delMap, jobKeys) {
      if (!delMap.hasOwnProperty('status')) {
        if (!this.isZh) {
          delMap.msg = delMap.msg.replace(this.$t('Message.PleaseRemoveTheTicketFirst'), 'please remove the ticket first')
          delMap.msg = delMap.msg.replace(this.$t('Message.ExpenseHasBeenEntered'), 'expense has been entered')
          delMap.msg = delMap.msg.replace(this.$t('Message.ConsolidationHasBeenDone'), 'consolidation has been done')
        }
        this.$message.warning(delMap.msg)
        return
      }
      this.$confirm(this.$t('CargoMsg.Cargo_DeleteConfirm'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(async() => {
        const loading = getLoading()
        this.context.loading = true
        try {
          const res = await batchDeleteJob({ jobKeys: jobKeys })
          await this.handlerDeleteResult(res, 'delete')
        } finally {
          loading.close()
          this.context.loading = false
        }
      }).catch(() => { })
    },
    // 删除成功处理
    async handlerDeleteResult(res, type) {
      const result = type === 'revoke' ? res.data.length : res.data
      if (result > 0) {
        const rows = this.selectedRows
        for (const row of rows) {
          const index = this.rowData.findIndex(p => p.uuid === row.uuid)
          if (index >= 0) {
            this.rowData.splice(index, 1)
          }
          if (row.lclMasterUuid) {
            const masterJob = this.rowData.find(p => p.uuid === row.lclMasterUuid)
            if (masterJob) {
              await new Job(masterJob).loadJobRelated({ job: true })
            }
          }
        }
        this.selectedRow = null
        if (type === 'revoke') {
          this.$message.success(this.$t('CargoMsg.Cargo_VoidedSuccessfully'))
        } else {
          this.$message.success(this.$t('Message.DeleteSuccessfully'))
        }
      }
    },
    // 导出公共
    addSeHandle() {
      switch (this.addSeCommand) {
        case this.$t('CargoMsg.Cargo_AddSeaBooking'):
          this.toAdd({ lob: 'SE' })
          break
        case this.$t('CargoMsg.Cargo_IntelligentDocumentRecognition'):
          this.jumpIntelligentBooking(INTELLIGENT_DOCUMENT_SOURCE_REMOTE_SE.code)
          break
      }
    },
    // 导出公共
    addAeHandle() {
      switch (this.addAeCommand) {
        case this.$t('CargoMsg.Cargo_AddAirBooking'):
          this.toAdd({ lob: AE.code })
          break
        case this.$t('CargoMsg.Cargo_IntelligentDocumentRecognition'):
          this.jumpIntelligentBooking(INTELLIGENT_DOCUMENT_SOURCE_REMOTE_AE.code)
          break
      }
    },
    // 远程订舱跳转 智能托书识别 模块
    jumpIntelligentBooking(source) {
      this.$router.push({
        name: 'OcrRecognition',
        query: { source, sourceBkg: source }
      })
    },
    onGridCellFocused(event) {
      // 等待gridApi被赋值
      this.$nextTick(async() => {
        // 等待gridApi被赋值
        await ensureExecuteSuccess(() => this.gridApi)
        if (this.gridApi && event.column) {
          this.gridApi.forEachNode(node => {
            if (node.rowIndex === event.rowIndex) {
              this.selectedRow = node.data
            }
          })
        }
      })
    },
    setOperationDateQueryData() {
      console.log('主应用发送OperationDateQuery:', this.operationDateQuery)
      microApp.forceSetData('child-operation-date-query-remotebooking', this.operationDateQuery)
    },
    operationDateQueryDataChange(e) {
      console.log('主应用获取OperationDateQuery:', e.detail.data)
      if (e.detail.data) {
        if (e.detail.data.type === 'created') {
          this.setOperationDateQueryData()
        } else {
          this.operationDateQuerySearch = e.detail.data.searchItem
          this.operationDateQueryColumn = e.detail.data.columnItem
          // 操作日期
          if (this.operationDateQuerySearch) {
            this.getCustomSearchItems().then(data => {
              this.customSearchItems = data
            })
          }
          if (this.operationDateQueryColumn && this.columnDefs.filter(item => ['customsDate'].includes(item.field)).length === 0) {
            this.columnDefs.push({
              headerName: this.$t('SeaExport.OperationDate'),
              field: 'customsDate',
              valueFormatter: params => {
                return ColumnUtils.dateLabelFunc(params.value)
              },
              width: 120
            })
          }
        }
      }
    },
    // 作废
    async toRevoke() {
      const rows = this.selectedRows
      if (rows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectDataToRevoke'))
        return
      }
      if (rows.length > 50) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SelectedMoreThenNPieces', [50]))
        return
      }
      const jobKeys = Array.from(rows, p => p.uuid)
      this.context.loading = true
      const loading = getLoading()
      const res = await validateRevokeJob({ jobKeys }).finally(() => {
        loading.close()
        this.context.loading = false
      })
      this.handleRevoke(res.data, jobKeys)
    },
    // 作废验证结构
    handleRevoke(delMap, jobKeys) {
      if (!delMap.hasOwnProperty('status')) {
        if (!this.isZh) {
          delMap.msg = delMap.msg.replace(this.$t('Message.PleaseRemoveTheTicketFirst'), 'please remove the ticket first')
          delMap.msg = delMap.msg.replace(this.$t('Message.ExpenseHasBeenEntered'), 'expense has been entered')
          delMap.msg = delMap.msg.replace(this.$t('Message.ConsolidationHasBeenDone'), 'consolidation has been done')
        }
        this.$message.warning({
          message: delMap.msg,
          dangerouslyUseHTMLString: true
        })
        return
      }
      this.$confirm(this.$t('CargoMsg.Cargo_SuredRevokeJob'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(async() => {
        const loading = getLoading()
        this.context.loading = true
        try {
          const res = await batchRevokeJob({ jobKeys: jobKeys })
          await this.handlerDeleteResult(res, 'revoke')
        } finally {
          loading.close()
          this.context.loading = false
        }
      }).catch(() => { })
    }
  }
}
</script>

<style scoped lang="scss">
#app .grid-view .main-content {
  .grid-wrapper ::v-deep {
    .ag-theme-balham {
      .ag-row-hover {
        background: #9bddff !important;
      }
    }
  }
}
</style>
